import { useState } from "react";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/common/States";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { brl } from "@/lib/format";

const FEATURES = {
  free: ["Até 5 alunos", "Agenda completa", "Controle básico de aulas", "Anotações de aula"],
  basic: ["Até 30 alunos", "Tudo do Gratuito", "Financeiro e mensalidades", "Relatórios", "Controle de presença", "Desempenho dos alunos"],
  pro: ["Alunos ilimitados", "Todos os recursos", "Relatórios avançados", "Lembretes automáticos", "WhatsApp (em breve)"],
};

export const PlanCards = ({ currentPlanId }) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(null);
  const plans = [
    { id: "free", name: "Gratuito", price: 0 },
    { id: "basic", name: "Básico", price: 29.9 },
    { id: "pro", name: "Profissional", price: 59.9, highlight: true },
  ];

  const choose = async (planId) => {
    if (!user || user.role !== "teacher") return navigate("/cadastro");
    if (planId === "free") return navigate("/configuracoes?tab=assinatura");
    setBusy(planId);
    try {
      const { data } = await api.post("/billing/checkout", { plan_id: planId, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(null);
    }
  };

  return (
    <div className="grid gap-5 md:grid-cols-3">
      {plans.map((p) => {
        const current = currentPlanId === p.id;
        return (
          <div key={p.id} className={`relative flex flex-col rounded-2xl border bg-card p-6 ${p.highlight ? "border-primary shadow-lg shadow-primary/10" : ""}`} data-testid={`plan-card-${p.id}`}>
            {p.highlight && <span className="absolute -top-3 left-6 rounded-full bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground">Mais completo</span>}
            <h3 className="font-heading text-xl font-bold">{p.name}</h3>
            <p className="mt-3"><span className="font-mono text-3xl font-semibold">{p.price ? brl(p.price) : "R$ 0"}</span><span className="text-sm text-muted-foreground">/mês</span></p>
            <ul className="mt-5 flex-1 space-y-2 text-sm">
              {FEATURES[p.id].map((f) => <li key={f} className="flex items-start gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0 text-accent" />{f}</li>)}
            </ul>
            <Button className="mt-6 w-full" variant={p.highlight ? "default" : "outline"} disabled={current || busy === p.id || (p.id === "free" && !!currentPlanId)} onClick={() => choose(p.id)} data-testid={`plan-choose-${p.id}`}>
              {busy === p.id && <Spinner className="mr-2" />}
              {current ? "Plano atual" : p.id === "free" ? (currentPlanId ? "Plano básico gratuito" : "Começar grátis") : "Assinar"}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
